import React from "react";
import { Icon } from "__ICON_REFERENCE__";
import { withLocalizer } from "utilities/withLocalizer";
import { CONFIGURATION } from "utilities/configuration";

function NextButton(props) {
    let { data, events } = props;
    let { currentStep, enabled } = data;

    if (currentStep > (CONFIGURATION.QUOTE_WIZARD_TOTAL_STEPS - 1)) return;

    return (
        <div className="wizard-button pull-right" >
            <div className={ "next-link-button font-bold font-16 filled-button-default button-1x" + (enabled ? "" : " disabled")} data-testid="next-button" onClick={async () => {
                if(!enabled) return;
                (currentStep === 1)
                    ? events?.isStep1DataValid(true) : (events && await events?.isStep2DataValid(true));
            }}>
                {props.localize("qma-navigation-next")}<Icon name="arrow-right" className="arrow-r" />
            </div>
        </div>
    );
}

export default withLocalizer(NextButton);